import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared';
import { PessoaTipoPipeModule } from '../../../../pessoa/tipo';
import { LeadContatoModule } from '../../contato';
import { OrigemPipeModule } from '../../../../common/origens/pipes';
import { CanalVendaInputGroupModule } from '../../../../common/canais-venda/components/input-group';
import { CanalMidiaSocialPipeModule } from '../../../../common/canal-midia-social/pipes';
import { IdentificadorMatrizFilialModule } from '../../../../common/identificador-matriz-filial';
import { NaturezaJuridicaFormControlModule } from '../../../../common/natureza-juridica/components/form-control';
import { PorteEmpresaFormControlModule } from '../../../../common/porte-empresa/components/form-control';
import { SimplesNacionalFormModule } from '../../../../common/simples-nacional';
import { MEIFormModule } from '../../../../common/mei';
import { CNAEsViewModule } from '../../../../cnaes/components/cnaes-view';
import { CNAEPipeModule } from '../../../../cnaes/pipes';
import { CapitalSocialFormControlTextModule } from '../../../../common/capital-social/form-control-text';
import { SocioViewModule } from '../../../../common/socios/view';

import { LeadFormInfoComponent } from './lead-form-info.component';

@NgModule({
    imports: [
        SharedModule,
        PessoaTipoPipeModule,
        LeadContatoModule,
        OrigemPipeModule,
        CanalVendaInputGroupModule,
        CanalMidiaSocialPipeModule,
        IdentificadorMatrizFilialModule,
        NaturezaJuridicaFormControlModule,
        PorteEmpresaFormControlModule,
        SimplesNacionalFormModule,
        MEIFormModule,
        CNAEsViewModule,
        CNAEPipeModule,
        CapitalSocialFormControlTextModule,
        SocioViewModule
    ],
    declarations: [
        LeadFormInfoComponent
    ],
    exports: [
        LeadFormInfoComponent
    ]
})
export class LeadFormInfoModule { }
